import * as yup from "yup";
import { useTranslation } from "react-i18next";

export const appl1945ValidationSchema = () => {
  const { t } = useTranslation();
  return yup.object().shape({
    d50_id: yup.object().required(t("Το πεδίο είναι υποχρεωτικό")),
    boardDate: yup
      .date()
      .required(t("Το πεδίο είναι υποχρεωτικό"))
      .typeError(t("Το πεδίο πρέπει να είναι ημερομηνία")),
    fudocPrakt1: yup.string().required(t("Το πεδίο είναι υποχρεωτικό")),
  });
};
